import React, { useState, useEffect, useContext } from 'react';
import Modal, { ModalBody, ModalHeader, ModalTitle, ModalFooter } from '../../../../components/bootstrap/Modal';
import Button from '../../../../components/bootstrap/Button';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Select from '../../../../components/bootstrap/forms/Select';
import showNotification from '../../../../components/extras/showNotification';
import { DefaultContext } from '../../../../contexts/default';
import api from '../../../../services/api';
import BillingScheduleDB from '../../../../database/wrappers/billingSchedule';

const PaymentDateModal = ({ isOpen, setIsOpen, selectedEstablishment }) => {
    const { estabSelected, establishments, stores } = useContext(DefaultContext);
    const [store, setStore] = useState('');
    const [emissionDay, setEmissionDay] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [scheduleData, setScheduleData] = useState(null);

    const [storeOptions, setStoreOptions] = useState([]);

    useEffect(() => {
        if (stores && stores.length > 0) {
            const options = stores.map(s => ({
                value: s.id,
                text: s.name
            }));
            setStoreOptions(options);

            if (options.length > 0 && !store && !selectedEstablishment) {
                setStore(options[0].value);
            }
        }
    }, [stores, store, selectedEstablishment]);

    useEffect(() => {
        if (isOpen && selectedEstablishment) {
            const storeId = selectedEstablishment.storeId || selectedEstablishment;
            setStore(storeId);
        }
    }, [isOpen, selectedEstablishment]);

    useEffect(() => {
        const fetchSchedule = async () => {
            if (!store) return;

            setIsLoading(true);
            try {
                const scheduleDB = new BillingScheduleDB();
                const data = await scheduleDB.getByStoreId(store);

                if (data) {
                    setScheduleData(data);

                    let dayToSet = 1;

                    if (data.nextChargeDate) {
                        if (data.nextChargeDate.toDate) {
                            dayToSet = data.nextChargeDate.toDate().getDate();
                        } else {
                            dayToSet = parseInt(data.nextChargeDate) || 1;
                        }
                    } else if (data.currentChargeDate) {
                        if (data.currentChargeDate.toDate) {
                            dayToSet = data.currentChargeDate.toDate().getDate();
                        } else {
                            const parsedDate = new Date(data.currentChargeDate);
                            if (!isNaN(parsedDate.getTime())) {
                                dayToSet = parsedDate.getDate();
                            } else {
                                dayToSet = parseInt(data.currentChargeDate) || 1;
                            }
                        }
                    }

                    setEmissionDay(dayToSet);
                } else {
                    setScheduleData(null);
                    setEmissionDay(1);
                }
            } catch (error) {
                showNotification(
                    'Erro',
                    'Falha ao carregar dados do agendamento',
                    'danger'
                );
            } finally {
                setIsLoading(false);
            }
        };

        if (isOpen && store) {
            fetchSchedule();
        }
    }, [isOpen, store]);

    const handleConfirm = async () => {
        if (!store) {
            showNotification('Atenção', 'Selecione uma loja', 'warning');
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                estabId: estabSelected,
                storeId: store,
                chargeDay: parseInt(emissionDay)
            };

            let successMessage = '';

            if (scheduleData) {
                await api.put('billing/schedule', {
                    storeId: store,
                    nextChargeDate: parseInt(emissionDay),
                    active: true
                });
                successMessage = 'Mudança de data para o proximo mês para o pagamento da assinatura';
            } else {
                await api.post('billing/schedule', payload);
                successMessage = 'Confirmado data de pagamento de assinatura';
            }

            showNotification(
                'Sucesso',
                successMessage,
                'success'
            );
            setIsOpen(false);
        } catch (error) {
            console.error("Erro ao salvar:", error);
            showNotification(
                'Erro',
                'Falha ao atualizar data de pagamento',
                'danger'
            );
        } finally {
            setIsLoading(false);
        }
    };

    const dayOptions = [
        { value: 1, text: 'Dia 01' },
        { value: 5, text: 'Dia 05' },
        { value: 10, text: 'Dia 10' },
        { value: 15, text: 'Dia 15' },
        { value: 20, text: 'Dia 20' },
        { value: 25, text: 'Dia 25' },
        { value: 30, text: 'Dia 30' },
    ];

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            titleId="payment-date-modal"
            isCentered
        >
            <ModalHeader className="p-4 pb-0 border-0" setIsOpen={setIsOpen}>
                <ModalTitle id="payment-date-modal-title" className="fw-bold">Data de pagamento</ModalTitle>
            </ModalHeader>
            <ModalBody className="p-4">
                <FormGroup label="Selecione a loja" className="mb-4">
                    <Select
                        ariaLabel="Selecione a loja"
                        list={storeOptions}
                        value={store}
                        onChange={(e) => setStore(e.target.value)}
                        disabled={isLoading}
                    />
                </FormGroup>

                <FormGroup label="Dia de emissão" className="mb-4">
                    <Select
                        ariaLabel="Dia de emissão"
                        list={dayOptions}
                        value={emissionDay}
                        onChange={(e) => setEmissionDay(e.target.value)}
                        disabled={isLoading}
                    />
                </FormGroup>

                <p className="text-muted small mb-0">
                </p>
            </ModalBody>
            <ModalFooter className="p-4 pt-0 border-0 justify-content-end gap-2">
                <Button
                    color="danger"
                    icon='Cancel'
                    onClick={() => setIsOpen(false)}
                    className="rounded-3"
                    disabled={isLoading}
                >
                    Cancelar
                </Button>
                <Button
                    color="success"
                    icon="Check"
                    onClick={handleConfirm}
                    className="rounded-3 text-white"
                    disabled={isLoading}
                >
                    {isLoading ? 'Salvando...' : 'Confirmar Alterações'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PaymentDateModal;
